import { makeStyles, Typography, Button, ButtonProps } from "@material-ui/core";
import { ITheme } from "../constants/theme";
import { buttonHoverAndActive } from "../utils/styles/buttonStyles";

interface IProps extends ButtonProps {
  title: string;
  noSetWidthAndHeight?: boolean;
}

export const PrimaryButton = ({ noSetWidthAndHeight, ...props }: IProps) => {
  const classes = useStyles();
  return (
    <Button
      className={
        !props.disabled
          ? noSetWidthAndHeight
            ? classes.noSetWidthAndHeightButton
            : classes.button
          : noSetWidthAndHeight
          ? classes.noSetWidthAndHeightButtonDisabled
          : classes.disabled
      }
      {...props}
    >
      <Typography variant="button" component="p" color="inherit">
        {props.title}
      </Typography>
    </Button>
  );
};

const useStyles = makeStyles((theme: ITheme) => ({
  button: {
    width: "80px",
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    ...buttonHoverAndActive
  },
  disabled: {
    width: "80px",
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    backgroundColor: theme.palette.action.disabledBackground,
  },
  noSetWidthAndHeightButton: {
    borderRadius: "8px",
    padding: "6px 16px",
    ...buttonHoverAndActive
  },
  noSetWidthAndHeightButtonDisabled: {
    borderRadius: "8px",
    padding: "6px 16px",
    backgroundColor: theme.palette.action.disabledBackground,
  },
}));
